<template>
  <div class="purchase-detail-content">
    <div v-if="basicProduct(data.pack).length > 0 || optionProduct(data.pack).length > 0" class="tbl01 purchase-detail-table">
      <table class="tbl">
        <colgroup>
          <col style="width:25%;">
          <col style="width:20%;">
          <col style="width:30%;">
          <col style="width:25%;">
        </colgroup>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th class="ta-center">購入ライセンス数</th>
            <th class="ta-center">ライセンス期限</th>
            <th class="ta-center">価格（税込）</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in basicProduct(data.pack)" :key="'basic_prod_' + index">
            <th>{{product.name}}</th>
            <td class="ta-center">{{product.license_number}}</td>
            <td class="ta-center">{{dateString(product.period_start, product.period_end)}}</td>
            <td class="ta-center">
              <template v-if="product.basic_price > 0 && product.add_price > 0 ">
                基本ライセンス　{{breakComma(product.basic_price)}}円
                <br>
                追加ライセンス　{{breakComma(product.add_price)}}円
              </template>
              <template v-else-if="product.basic_price > 0">
                基本ライセンス　{{breakComma(product.basic_price)}}円
              </template>
              <template v-else-if="product.add_price > 0">
                追加ライセンス　{{breakComma(product.add_price)}}円
              </template>
              <template v-else-if="product.basic_price === 0 && product.add_price === 0 ">
                無料
              </template>
            </td>
          </tr>
          <tr v-for="(product, index) in optionProduct(data.pack)" :key="'option_prod_' + index">
            <th class="pl40">{{product.name}}</th>
            <td class="ta-center">{{product.license_number}}</td>
            <td class="ta-center">{{dateString(product.period_start, product.period_end)}}</td>
            <td class="ta-center">
              <template v-if="product.basic_price !== null">基本ライセンス　{{breakComma(product.basic_price)}}円</template>
              <br v-if="product.basic_price !== null && product.add_price !== null">
              <template v-if="product.add_price !== null">追加ライセンス　{{breakComma(product.add_price)}}円</template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { PurchaseTable } from '@/logic/contract/PurchaseTable'

export default defineComponent({
  name: 'PurchaseTable',
  props: {
    pack: {
      type: Object,
      default: null
    }
  },
  setup (props, context) {
    return { ...PurchaseTable(props, context) }
  }
})
</script>
